import React, { useState } from "react";
import axios from "axios";

export default function AddUser({ onUserAdded }) {
  const [form, setForm] = useState({
    full_name: "",
    email: "",
    phone: "",
    password: "",
    confirm_password: "",
    role: "customer",
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      await axios.post("/api/auth/register", form);
      setMessage("تم إضافة المستخدم بنجاح ✅");
      setForm({
        full_name: "",
        email: "",
        phone: "",
        password: "",
        confirm_password: "",
        role: "customer",
      });
      if (onUserAdded) onUserAdded();
    } catch (err) {
      setMessage(err.response?.data?.message || "حدث خطأ ما ❌");
    }

    setLoading(false);
  };

  return (
    <div className="card add-user-card">
      <h2>إضافة مستخدم جديد</h2>
      {message && <p className="message">{message}</p>}
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          name="full_name"
          placeholder="الاسم الكامل"
          value={form.full_name}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          name="email"
          placeholder="البريد الإلكتروني"
          value={form.email}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="phone"
          placeholder="رقم الهاتف"
          value={form.phone}
          onChange={handleChange}
          required
        />
        <input
          type="password"
          name="password"
          placeholder="كلمة المرور"
          value={form.password}
          onChange={handleChange}
          required
        />
        <input
          type="password"
          name="confirm_password"
          placeholder="تأكيد كلمة المرور"
          value={form.confirm_password}
          onChange={handleChange}
          required
        />

        <select name="role" value={form.role} onChange={handleChange}>
          <option value="customer">زبون</option>
          <option value="admin">مدير</option>
          <option value="hotel">فندق</option>
          <option value="delivery">توصيل</option>
        </select>

        <button type="submit" disabled={loading}>
          {loading ? "جاري الإضافة..." : "إضافة مستخدم"}
        </button>
      </form>

      {/* --- CSS --- */}
   
    </div>
  );
}
